import { silenceAbortErrors } from './utils/silenceAbortErrors';

// Silence search abort errors
silenceAbortErrors();

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';

// Components
import NavDropdown from './react/components/shared/NavDropdown';
import FavoriteMealEditorPage from './react/components/shared/FavoriteMealEditorPage';
import FavoriteAddModal from './react/components/shared/FavoriteAddModal';
import FavoriteModal from './react/components/shared/FavoriteModal';
import FoodItemModal from './react/components/shared/FoodItemModal';
import PrintBtn from './react/components/shared/PrintBtn';

// Diary Components
import DiaryContent from './react/components/diary/DiaryContent';
import DiaryDatePicker from './react/components/diary/DiaryDatePicker';
import DiaryModal from './react/components/diary/DiaryModal';
import DiaryNutrition from './react/components/diary/DiaryNutrition';
import DiarySubmenu from './react/components/diary/DiarySubmenu';

const components = {
    DiarySubmenu,
    DiaryDatePicker,
    DiaryContent,
    DiaryModal,
    NavDropdown,
    DiaryNutrition,
    PrintBtn,
    FoodItemModal,
    FavoriteModal,
    FavoriteAddModal,
    FavoriteMealEditorPage
};

const queryClient = new QueryClient();

document.querySelectorAll('[data-react-component]').forEach((el) => {
    const name = el.dataset.reactComponent;
    const Component = components[name];
    if (!Component) return;

    // Parse props if any
    let props = {};
    if (el.dataset.props) {
        try {
            props = JSON.parse(el.dataset.props);
        } catch (e) {
            console.error('Failed to parse props for', name, e);
        }
    }

    ReactDOM.createRoot(el).render(
        <QueryClientProvider client={queryClient}>
            <Component {...props} />
        </QueryClientProvider>
    );
});
